import { Schedule } from "../utils/types/sccmSchedules"
import { PMCSchedule } from "./pmcScheduling"

interface Subscription {
  azSubscription: string
  azSubscriptionName: string
}

export interface StateType {
  itPlatform: number
  platformName: string
  platformCode: string
  subnet: string
  vpc: string
  businessService: string
  application: string
  applicationNames: string[]
  isInValidCombination: boolean
  isDataFoundationUser: boolean
  dataFoundationUsers: any[]
  serviceOwner: string
  numberOfVms: number
  environment: string
  environmentOptions: string[]
  regionOptions: { value: string; label: string }[]
  vpcNetworkProjects: string[]
  zone: string
  vmConfigs: Array<{
    os: string
    vmSize: string
    zone: string
    imageFamilyName: string
    serverRole: string
    //customServerRole: string //To be used in future if we want to allow users to enter custom server roles
    diskConfigs: Array<{
      type: string
      size: number
    }>
    selectedSchedule: Schedule | null
    selectedPMCSchedule: PMCSchedule | null
    spotVmEnabled?: boolean
    serviceAliases?: Array<{
      shortName: string
      type: 'A Record' | 'CNAME Record'
    }>
    aliasIpRanges?: Array<{
      ipCidrRange: string
      subnetworkRangeName?: string
    }>
  }>
  isSaveEnabledTab2: boolean
  imageOptions: { value: string; label: string }[]
  isSaveEnabledTab3: boolean
  allFilteredData: string[] // Ensure Application interface is properly defined
  filteredApplicationData: Application[] // Ensure Application interface is properly defined
  tabValue2: number
  subnetDetails: string[]
  vpcType: string
  region: string
  isFetchingSubnets: boolean
  vmProject: string
  vmProjectOptions: string[]
  OptInOutOptions: { value: string; label: string }[]
  optInOptOut: string,
  remarks: string,
  envOptions: { value: string; label: string }[]
  zoneOptions: { value: string; label: string }[]
  vNetToSubnetsMap: any
  subscriptionId: string
  selectedSubscriptionName: string
  lastTwoCharacters: string
  listOfSubscriptions: Subscription[] // Updated based on structure of subscription data
  resourceGroupNames: string[]
  assetTag: string
  assetTagNames: string[]
  environmentType: string
  availabilityZone: string
  diagStorageAcc: string
  azureRegion: string
  rgName: string
  rgLocation: string
  rgId: string
  virtualNetworkNames: string[]
  virtualSubNetworkNames: string[]
  firstNetworkRgName: string
  selectedNetworkRgName: string
  vnetName: string // Virtual Network name
  subnetName: string // Subnet name
  vmConfigsAzure: Array<{
    os: string
    vmSize: string
    availabilityZone: string
    diagStorageAcc: string
    serverPersona: string
    backupPolicy: string
    diskConfigs: Array<{
      type: string
      size: number
    }>
    selectedSchedule: Schedule | null
    selectedPMCSchedule: PMCSchedule | null
    asgRequired: boolean // new field to check if ASG is required
    asgType: 'existing' | 'new' | null // 'existing' or 'new'
    asgRoles?: string[] // array of roles when asgType is 'new'
    asgNames?: string[] // array of ASG names when asgType is 'existing'
    winLicenseType?: boolean
    spotVmEnabled?: boolean
  }>
  osOptions: string[]
  nsgNames: string[]
  nsgName: string
  asgNames: string[]
  asgName: string
  nsgSliderEnabled: boolean
  nsgAssociationType: 'existingNSG' | 'createnew' | '' // Add this
  nsgType: '' // Add this if needed
  nsgLocation: '' // Add this if location is tracked

  networkRgNames: string[]
  platformShortCode: string
  extractedShortCode: string
  regionalName: string
  uniqueApplicationData: string[]
}
export const initialState: StateType = {
  itPlatform: 0,
  platformName: '',
  platformCode: '',
  subnet: '',
  vpc: '',
  businessService: '',
  application: '',
  applicationNames: [],
  isInValidCombination: false, // Assuming this is a boolean
  isDataFoundationUser: false,
  dataFoundationUsers: [],
  serviceOwner: '',
  environment: '',
  environmentOptions: [],
  regionOptions: [],
  zoneOptions: [],
  OptInOutOptions: [],
  vpcNetworkProjects: [],
  zone: '',
  vmConfigs: [
    {
      os: '', // Default OS value
      vmSize: '', // Default VM Size (assuming you have a structure for it)
      zone: '', // Default availability zone
      imageFamilyName: '',
      serverRole: '',
      //customServerRole: '',
      diskConfigs: [], // Initialize with an empty array of disks
      selectedSchedule: null,
      selectedPMCSchedule: null,
      spotVmEnabled: false,
      serviceAliases: [],
      aliasIpRanges: []
    }
  ],
  isSaveEnabledTab2: false,
  imageOptions: [],
  numberOfVms: 1,
  isSaveEnabledTab3: false,
  allFilteredData: [], // This should be an array of Application objects
  filteredApplicationData: [], // This should be an array of Application objects
  tabValue2: 0,
  subnetDetails: [],
  vpcType: '',
  region: '',
  isFetchingSubnets: true,
  vmProject: '',
  vmProjectOptions: [],
  optInOptOut: '',
  remarks: '',
  envOptions: [],
  vNetToSubnetsMap: null,
  subscriptionId: '',
  selectedSubscriptionName: '',
  lastTwoCharacters: '',
  listOfSubscriptions: [],
  resourceGroupNames: [],
  assetTag: '',
  assetTagNames: [],
  environmentType: '',
  availabilityZone: '',
  diagStorageAcc: '',
  azureRegion: '',
  rgName: '',
  rgLocation: '',
  rgId: '',
  virtualNetworkNames: [],
  virtualSubNetworkNames: [],
  firstNetworkRgName: '',
  selectedNetworkRgName: '',
  vnetName: '', // Virtual Network name
  subnetName: '', // Subnet name
  vmConfigsAzure: [
    {
      os: '', // Default OS value
      vmSize: '', // Default VM Size (assuming you have a structure for it)
      availabilityZone: '', // Default availability zone
      diagStorageAcc: '',
      serverPersona: '', // Default server persona value
      backupPolicy: '', // Default backup policy value
      diskConfigs: [], // Initialize with an empty array of disks
      selectedSchedule: null,
      selectedPMCSchedule: null,
      asgRequired: false,
      asgType: null, // Undefined until user selects ASG type
      asgNames: [], // Empty array, only populated if 'existing' ASG is selected
      asgRoles: [],
      winLicenseType: false, //  Added new field for Windows BYOL licensing
      spotVmEnabled: false
    }
  ],
  osOptions: [],
  nsgSliderEnabled: false,
  nsgNames: [],
  nsgName: '',
  asgNames: [],
  asgName: '',
  nsgAssociationType: '', // Add this
  nsgType: '', // Add this if needed
  nsgLocation: '', // Add this if location is tracked
  networkRgNames: [],
  platformShortCode: '',
  extractedShortCode: '',
  regionalName: '',
  uniqueApplicationData: []
}

export const availableImage = [
  { value: 'win19', label: 'Windows 2019' },
  { value: 'win22', label: 'Windows 2022' },
  { value: 'win25', label: 'Windows 2025' },
  { value: 'rhel7', label: 'RHEL 7' },
  { value: 'rhel8', label: 'RHEL 8' },
  { value: 'rhel9', label: 'RHEL 9' }
]

export const availableServerPersona = [
  { value: 'Azure', label: 'Standard VM' },
  { value: 'Networker', label: 'Database VM' }
]

export const availableBackupPolicies = [
  { value: 'standard-vm-bp-1900UTC-daily', label: 'standard-vm-bp-1900UTC-daily' },
  { value: 'standard-vm-bp-2000UTC-daily', label: 'standard-vm-bp-2000UTC-daily' },
  { value: 'standard-vm-bp-2200UTC-daily', label: 'standard-vm-bp-2200UTC-daily' },
  { value: 'standard-vm-bp-2300UTC-daily', label: 'standard-vm-bp-2300UTC-daily' },
  { value: 'standard-vm-bp-1900UTC-Mon-parked', label: 'standard-vm-bp-1900UTC-Mon-parked' }
]

const optInoptOut = [
  { label: 'In', value: 'In' },
  { label: 'Out', value: 'Out' }
]

export const unifiedReducer = (state: StateType, action: { type: string, payload?: any, platform?: 'azure' | 'gcp' }): StateType => {
  switch (action.type) {
    case 'SET_IT_PLATFORM':
      return { ...state, itPlatform: action.payload }
    case 'SET_PLATFORM_DETAILS':
      return {
        ...state,
        platformName: action.payload.platformName,
        platformCode: action.payload.platformCode
      }
    case 'RESET_FIELDS':
      return {
        ...state,
        businessService: '',
        application: '',
        filteredApplicationData: [], // Clear filtered application data
        vmConfigs: [
          {
            os: '', // Default OS value
            vmSize: '', // Default VM Size (assuming you have a structure for it)
            zone: '', // Default availability zone
            imageFamilyName: '',
            serverRole: '',
            //customServerRole: '',
            diskConfigs: [], // Initialize with an empty array of disks
            selectedSchedule: null,
            selectedPMCSchedule: null,
            spotVmEnabled: false
          }
        ],
        vmProject: ''
      }
    case 'CLEAR_NETWORK_SETTINGS':
      return { ...state, subnetDetails: [], subnet: '', vpc: '', platformCode: state.platformCode }
    case 'SET_OPTINOUT_OPTIONS':
      return { ...state, OptInOutOptions: optInoptOut }
    case 'SET_VPC_NEWTWORK_PROJECT_OPTIONS':
      return { ...state, vpcNetworkProjects: action.payload }
    case 'SET_VM_PROJECT':
      return {
        ...state,
        vmProject: action.payload
      }
    case 'SET_SUBNET':
      return {
        ...state,
        subnet: action.payload,
      }
    case 'SET_REGIONAL_NAME':
      return { ...state, regionalName: action.payload }
    case 'SET_VPC_TYPE':
      return { ...state, vpcType: action.payload }
    case 'SET_VPC':
      return { ...state, vpc: action.payload }
    case 'SET_ALL_FILTERED_DATA':
      return { ...state, allFilteredData: action.payload.allFilteredData }
    case 'SET_FILTERED_APPLICATION_DATA':
      return { ...state, filteredApplicationData: action.payload.filteredApplicationData }
    case 'SET_UNIQUE_APPLICATION_DATA':
      return { ...state, uniqueApplicationData: action.payload.uniqueApplicationData }
    case 'SET_SERVICE_OWNER':
      return { ...state, serviceOwner: action.payload.serviceOwner }
    case 'SET_BUSINESS_SERVICE':
      return { ...state, businessService: action.payload.businessService }
    case 'APPLICATION_CHANGE':
      // Reset project since project options are scoped to the selected application
      return { ...state, application: action.payload.application, vmProject: '' }
    case 'SET_REGION_OPTIONS': {
      let options: any[]
      if (action.platform === 'azure') {
        options = [
          { value: 'bieno North Europe', label: 'North Europe' },
          { value: 'bnlwe West Europe', label: 'West Europe' }
        ]
      } else if (action.platform === 'gcp') {
        options = [
          { label: 'Netherland Region', value: 'europe-west4' },
          { label: 'Frankfurt Region', value: 'europe-west3' }
        ]
      } else {
        options = []
      }
      return { ...state, regionOptions: options }
    }
    case 'SET_ENVIRONMENT_TYPE': {
      if (action.platform === 'gcp') {
        return { ...state, environment: action.payload }
      } else if (action.platform === 'azure') {
        return { ...state, environmentType: action.payload }
      }
    }
    case 'SET_ENV_OPTIONS': {
      let options
      // Determine environment options based on platform
      if (action.platform === 'azure') {
        options = [
          { value: 'Development', label: 'Development' },
          { value: 'QA', label: 'QA' },
          { value: 'Training', label: 'Education & Training' },
          { value: 'Innovation', label: 'Innovation & Testing' },
          { value: 'Non-specific', label: 'Non-Specific' },
          { value: 'Performance', label: 'Performance Testing' },
          { value: 'Preprod', label: 'Pre-Prod (UAT)' },
          { value: 'Production', label: 'Production' },
          { value: 'Sandbox', label: 'Sandbox' }
        ]
      } else if (action.platform === 'gcp') {
        options = [
          { value: 'development', label: 'Development' },
          { value: 'qa', label: 'QA' },
          { value: 'training', label: 'Education & Training' },
          { value: 'innovation', label: 'Innovation & Testing' },
          { value: 'non-specific', label: 'Non-Specific' },
          { value: 'performance', label: 'Performance Testing' },
          { value: 'pre-prod', label: 'Pre-Production (UAT)' },
          { value: 'production', label: 'Production' },
          { value: 'sandbox', label: 'Sandbox' }
        ]
      } else {
        options = []
      }
      const sortedOptions = options.sort((a, b) => a.label.localeCompare(b.label))
      return { ...state, envOptions: sortedOptions }
    }
    case 'SET_VM_PROJECT_OPTIONS':
      return {
        ...state,
        vmProjectOptions: action.payload, // Set the available VM projects from the action payload
      }
    case 'SET_OPT_IN_OUT':
      return {
        ...state,
        optInOptOut: action.payload,
      }
    case 'SET_REMARKS':
      return {
        ...state,
        remarks: action.payload,
      }
    case 'ADD_VM':
      if (action.platform === 'gcp') {
        // Use spotVmEnabled from payload if provided, otherwise default to false
        const spotVmEnabledValue = action.payload?.newVmConfig?.spotVmEnabled ?? false
        return {
          ...state,
          vmConfigs: [
            ...state.vmConfigs,
            {
              vmSize: '',
              zone: '', // Default for AZ
              os: '', // Default for OS
              diskConfigs: [],
              imageFamilyName: '',
              serverRole: '',
              //customServerRole: '',
              selectedSchedule: null,
              selectedPMCSchedule: null,
              spotVmEnabled: spotVmEnabledValue              // Add other default values as needed
            }
          ]
        }
      }
      else if (action.platform === 'azure') {
        // Determine spotVmEnabled default based on current subscription
        const spotVmEnabledDefault =
          state.selectedSubscriptionName === 'CPS Product Testing-01' ||
          state.selectedSubscriptionName === 'CPS Product Testing-02'
        return {
          ...state,
          vmConfigsAzure: [
            ...state.vmConfigsAzure,
            {
              vmSize: '',
              availabilityZone: '', // Default for AZ
              diagStorageAcc: '',
              os: '', // Default for OS
              serverPersona: '', // Default server persona value
              backupPolicy: '', // Default backup policy value
              diskConfigs: [],
              // Add other default values as needed
              selectedSchedule: null, // New default value for selectedSchedule
              asgRequired: false,
              asgType: null, // Undefined until user selects ASG type
              asgNames: [], // Empty array, only populated if 'existing' ASG is selected
              asgRoles: [],
              selectedPMCSchedule: null,
              spotVmEnabled: spotVmEnabledDefault
            }
          ]
        }
      }
    case 'UPDATE_AVAILABILITY_ZONE': {
      const updatedVmConfigs = state.vmConfigs.map((config, index) => {
        if (index === action.payload.index) {
          return {
            ...config,
            availabilityZone: action.payload.availabilityZone
          }
        }
        return config
      })
      return {
        ...state,
        vmConfigs: updatedVmConfigs
      }
    }
    case 'REMOVE_VM': {
      const { index, platform } = action.payload

      const removeVMFromConfigs = (vmConfigs) => [
        ...vmConfigs.slice(0, index),
        ...vmConfigs.slice(index + 1),
      ]

      if (platform === 'gcp') {
        return {
          ...state,
          vmConfigs: removeVMFromConfigs(state.vmConfigs), // Update GCP-specific vmConfigs
        }
      } else if (platform === 'azure') {
        return {
          ...state,
          vmConfigsAzure: removeVMFromConfigs(state.vmConfigsAzure), // Update Azure-specific vmConfigs
        }
      }
      return state
    }
    case 'SET_TAB_VALUE2': {
      return {
        ...state,
        tabValue2: action.payload
      }
    }
    case 'SET_IMAGE_OPTIONS':
      return {
        ...state,
        imageOptions: availableImage // Store the available OS options in the state
      }
    case 'SET_ZONE_OPTIONS':
      let options
      // Determine environment options based on platform
      if (action.platform === 'azure') {
        options = [
          { value: '1', label: '1' },
          { value: '2', label: '2' },
          { value: '3', label: '3' },
        ]
      } else if (action.platform === 'gcp') {
        options = [
          { value: 'a', label: 'Zone a' },
          { value: 'b', label: 'Zone b' },
          { value: 'c', label: 'Zone c' },
        ]
      } else {
        options = []
      }
      return {
        ...state,
        zoneOptions: options // Store the available OS options in the state
      }
    case 'FETCH_SUBNETS_INIT':
      return { ...state, isFetchingSubnets: true }

    case 'SET_SUBNET_DETAILS':
      return {
        ...state,
        subnetDetails: action.payload,
        isFetchingSubnets: false
      }
    case 'FETCH_SUBNETS_ERROR':
      return { ...state, subnetDetails: [], isFetchingSubnets: false }

    case 'SET_SAVE_ENABLED_TAB':
      // Based on which tab to enable (2 or 3)
      if (action.payload.tab === 2) {
        return {
          ...state,
          isSaveEnabledTab2: action.payload.enabled
        }
      } else if (action.payload.tab === 3) {
        return {
          ...state,
          isSaveEnabledTab3: action.payload.enabled
        }
      }
      break
    case 'LOAD_DATA':
      if (action.platform === 'gcp') {
        return {
          ...state,
          ...action.payload,
          itPlatform: action.payload.itPlatform || state.itPlatform,
          remarks: action.payload.remarks || state.remarks,
          vmProject: action.payload.vmProject || state.vmProject,
          subnetDetails: action.payload.subnetDetails || state.subnetDetails,
          region: action.payload.region || state.region,
          businessService: action.payload.businessService || state.businessService,
          application: action.payload.application || state.application,
          environment: action.payload.environment || state.environment,
          vpcType: action.payload.vpcType || state.vpcType,
          subnet: action.payload.subnet || state.subnet,
          vpc: action.payload.vpc || state.vpc,
          serviceOwner: action.payload.serviceOwner || state.serviceOwner,
          optInOptOut: action.payload.optInOptOut,
          vmConfigs: action.payload.vmConfigs || state.vmConfigs, // Ensure vmConfigs are correctly updated
        }
      }
      else if (action.platform === 'azure') {
        console.log('Reducer LOAD_DATA Payload:', action.payload)
        return {
          ...state,
          ...action.payload,
          selectedNetworkRgName: action.payload.vnet_rg_name || state.selectedNetworkRgName,
          vnetName: action.payload.vnetName || state.vnetName,
          subnetName: action.payload.subnetName || state.subnetName,
          resourceGroupNames: action.payload.resourceGroupNames || state.resourceGroupNames,
          azureRegion: action.payload.azureRegion || state.azureRegion,
          vmConfigs: action.payload.vmConfigsAzure || state.vmConfigsAzure, // Ensure vmConfigs are updated correctly
          availabilityZone: action.payload.availabilityZone || state.availabilityZone,
          diagStorageAcc: action.payload.diagStorageAcc || state.diagStorageAcc,
          nsgSliderEnabled: action.payload.nsgName && action.payload.nsgLocation ? true : state.nsgSliderEnabled // Enable NSG slider if nsg_name exists
        }
      }
    case 'RESET_ALL_FIELDS':
      if (action.platform === 'gcp') {
        return {
          ...state,
          itPlatform: '',
          businessService: '',
          application: '',
          applicationNames: [],
          filteredApplicationData: [], // Clear filtered application data
          vmProject: '',
          //   vmProjectOptions: [],
          vpcType: '',
          subnet: '',
          subnetDetails: [],
          environment: '',
          remarks: '',
          region: '',
          vpc: '',
          serviceOwner: '',
          numberOfVms: 1,
          os: '',
          vmConfigs: [
            {
              os: '', // Default OS value
              vmSize: '', // Default VM Size (assuming you have a structure for it)
              zone: '', // Default availability zone
              imageFamilyName: '',
              serverRole: '',
              //customServerRole: '',
              diskConfigs: [], // Initialize with an empty array of disks
              selectedSchedule: null,
              selectedPMCSchedule: null,
              spotVmEnabled: false
            }
          ]
        }
      }
      else if (action.platform === 'azure') {
        return {
          ...state,
          itPlatform: '',
          businessService: '',
          application: '',
          applicationNames: [],
          subscriptionId: '',
          selectedSubscriptionName: '',
          rgId: '',
          rgLocation: '',
          rgName: '',
          listOfSubscriptions: [],
          resourceGroupNames: [],
          assetTag: '',
          assetTagNames: [],
          environmentType: '',
          azureRegion: '',
          virtualNetworkNames: [],
          virtualSubNetworkNames: [],
          vnetName: '',
          subnetName: '',
          serviceOwner: '',
          numberOfVms: 1,
          os: '',
          availabilityZone: '',
          vmConfigsAzure: [
            {
              os: '', // Default OS value
              vmSize: '', // Default VM Size (assuming you have a structure for it)
              availabilityZone: '', // Default availability zone
              diagStorageAcc: '',
              serverPersona: '', // Default server persona value
              backupPolicy: '', // Default backup policy value
              diskConfigs: [], // Initialize with an empty array of disks
              selectedSchedule: null,
              asgRequired: false,
              asgType: null, // Undefined until user selects ASG type
              asgNames: [], // Empty array, only populated if 'existing' ASG is selected
              asgRoles: [],
              selectedPMCSchedule: null
            }
          ],
          nsgSliderEnabled: false,
          nsgNames: [],
          nsgName: '',
          nsgLocation: '',
          nsgType: '',
          nsgAssociationType: '',
          networkRgNames: [],
          selectedNetworkRgName: ''
        }
      }

    case 'TOGGLE_ASG_REQUIRED': {
      const updatedVmConfigs = [...state.vmConfigsAzure]
      const { index } = action.payload

      // Ensure index exists before modifying
      if (!updatedVmConfigs[index]) return state

      updatedVmConfigs[index] = {
        ...updatedVmConfigs[index],
        asgRequired: !updatedVmConfigs[index].asgRequired,
      }

      // Reset fields when ASG is disabled
      if (!updatedVmConfigs[index].asgRequired) {
        updatedVmConfigs[index].asgType = null
        updatedVmConfigs[index].asgRoles = []
        updatedVmConfigs[index].asgNames = []
      }

      return { ...state, vmConfigsAzure: updatedVmConfigs }
    }


    case 'SET_ASG_TYPE': {
      const { index, value: asgType } = action.payload
      const updatedVmConfigs = [...state.vmConfigsAzure]

      // Ensure index exists before modifying
      if (!updatedVmConfigs[index]) return state

      updatedVmConfigs[index] = {
        ...updatedVmConfigs[index],
        asgType,
        asgRoles: [],
        asgNames: [],
      }

      return { ...state, vmConfigsAzure: updatedVmConfigs }
    }

    case 'SET_ASG_ROLES': {
      const { index, value: asgRoles } = action.payload
      const updatedVmConfigs = [...state.vmConfigsAzure]

      if (!updatedVmConfigs[index]) return state

      updatedVmConfigs[index] = {
        ...updatedVmConfigs[index],
        asgRoles,
      }

      return { ...state, vmConfigsAzure: updatedVmConfigs }
    }

    case 'SET_ASG_NAME': {
      const { index, value: asgNames } = action.payload
      const updatedVmConfigs = [...state.vmConfigsAzure]

      if (!updatedVmConfigs[index]) return state

      updatedVmConfigs[index] = {
        ...updatedVmConfigs[index],
        asgNames: Array.isArray(asgNames) ? asgNames : [], // Ensure it's an array
      }

      return { ...state, vmConfigsAzure: updatedVmConfigs }
    }
    case 'CLEAR_ASG_NAMES_IN_VMS': {
      const updatedVmConfigs = state.vmConfigsAzure.map((vmConfig) => ({
        ...vmConfig,
        asgNames: [], // Reset asgNames for all VM configs
      }))
      return { ...state, vmConfigsAzure: updatedVmConfigs }
    }

    case 'SET_SUBSCRIPTION':
      const { subscriptionId, selectedSubscriptionName } = action.payload
      const lastTwoChars = selectedSubscriptionName.slice(-2)
      let updatedVmConfigsAzure = state.vmConfigsAzure
      if (
        selectedSubscriptionName === 'CPS Product Testing-01' ||
        selectedSubscriptionName === 'CPS Product Testing-02'
      ) {
        updatedVmConfigsAzure = state.vmConfigsAzure.map(vm => ({
          ...vm,
          spotVmEnabled: true
        }))
      } else {
        updatedVmConfigsAzure = state.vmConfigsAzure.map(vm => ({
          ...vm,
          spotVmEnabled: false
        }))
      }
      return {
        ...state,
        subscriptionId,
        selectedSubscriptionName,
        resourceGroupNames: action.payload.resourceGroupNames,
        isInValidCombination: action.payload.isInValidCombination,
        vmConfigsAzure: updatedVmConfigsAzure
      }
    case 'SET_SUBSCRIPTIONS':
      return {
        ...state,
        listOfSubscriptions: action.payload // Update the list of subscriptions from the action payload
      }
    case 'SET_SHORTCODE':
      return {
        ...state,
        extractedShortCode: action.payload,
      }
    case 'SET_LAST_TWO_CHARACTERS':
      return {
        ...state,
        lastTwoCharacters: action.payload,
      }
    case 'SET_ASSET_TAG_NAMES':
      return { ...state, assetTagNames: action.payload }
    case 'SET_ASSET_TAG':
      return { ...state, assetTag: action.payload }
    case 'SET_RG_NAME':
      return { ...state, rgName: action.payload }
    case 'SET_RG_ID':
      return { ...state, rgId: action.payload }
    case 'SET_REGION':
      if (action.platform === 'gcp') {
        return {
          ...state,
          region: action.payload
        }
      }
      else if (action.platform === 'azure') {
        return {
          ...state,
          rgLocation: action.payload
        }
      }
    case 'SET_ENVIRONMENT_TYPE':
      if (action.platform === 'gcp') {
        return {
          ...state,
          environment: action.payload
        }
      }
      else if (action.platform === 'azure') {
        return {
          ...state,
          environmentType: action.payload
        }
      }
    case 'SET_AZURE_REGION':
      const updatedState = { ...state, azureRegion: action.payload }
      return updatedState

    case 'SET_VIRTUAL_NETWORK_NAMES':
      return { ...state, virtualNetworkNames: action.payload }
    case 'SET_VNET_TO_SUBNETS_MAP':
      return { ...state, vNetToSubnetsMap: action.payload }
    case 'SET_VNET_NAME':
      return { ...state, vnetName: action.payload }
    case 'SET_VIRTUAL_SUBNET_NAMES':
      return { ...state, virtualSubNetworkNames: action.payload }
    case 'SET_SUBNET_NAME':
      return { ...state, subnetName: action.payload }
    case 'SET_VNET_AND_SUBNET': {
      const { vnetName, subnetName } = action.payload
      // Retrieve the subnets for the selected VNET from the state
      const subnetsForSelectedVnet = state.vNetToSubnetsMap[vnetName] || []
      return { ...state, virtualSubNetworkNames: subnetsForSelectedVnet, subnetName: subnetName || '' }
    }
    case 'UPDATE_AVAILABILITY_ZONE': {
      const updatedVmConfigs = state.vmConfigs.map((config, index) => {
        if (index === action.payload.index) {
          return {
            ...config,
            availabilityZone: action.payload.availabilityZone
          }
        }
        return config
      })
      return {
        ...state,
        vmConfigs: updatedVmConfigs
      }
    }
    case 'REMOVE_DISK': {
      const { vmIndex, diskIndex, platform } = action.payload

      // Helper function to remove a disk from vmConfigs
      const removeDiskFromConfigs = (vmConfigs) =>
        vmConfigs.map((vm, index) => {
          if (index === vmIndex) {
            return {
              ...vm,
              diskConfigs: vm.diskConfigs.filter((_, i) => i !== diskIndex), // Remove the specific disk
            }
          }
          return vm // Return unchanged VMs for other indices
        })

      if (platform === 'gcp') {
        return {
          ...state,
          vmConfigs: removeDiskFromConfigs(state.vmConfigs), // Update GCP-specific vmConfigs
        }
      } else if (platform === 'azure') {
        return {
          ...state,
          vmConfigsAzure: removeDiskFromConfigs(state.vmConfigsAzure), // Update Azure-specific vmConfigs
        }
      }
      return state
    }
    case 'SET_TAB_VALUE2': {
      return {
        ...state,
        tabValue2: action.payload
      }
    }
    case 'UPDATE_VM_CONFIG': {
      const { index, key, value, platform } = action.payload

      const updateConfigs = (vmConfigs) =>
        vmConfigs.map((vm, idx) => {
          if (idx === index) {
            return {
              ...vm,
              [key]: value, // Update the specific field (OS, VM size, etc.)
            }
          }
          return vm // Return unchanged VMs for other indices
        })

      if (platform === 'gcp') {
        return {
          ...state,
          vmConfigs: updateConfigs(state.vmConfigs),
        }
      } else if (platform === 'azure') {
        return {
          ...state,
          vmConfigsAzure: updateConfigs(state.vmConfigsAzure),
        }
      }
      return state
    }
    case 'SET_OS_OPTIONS':
      return {
        ...state,
        osOptions: action.payload // Store the available OS options in the state
      }
    case 'UPDATE_DISK_CONFIG': {
      const { vmIndex, diskIndex, key, value, platform } = action.payload

      const updateConfigs = (vmConfigs) => {
        // Copy the vmConfigs array to avoid direct mutation
        const updatedVMs = [...vmConfigs]

        // Copy the specific VM's diskConfigs array to avoid direct mutation
        const updatedDisks = [...updatedVMs[vmIndex].diskConfigs]

        // Update the specific disk's property
        updatedDisks[diskIndex] = {
          ...updatedDisks[diskIndex],
          [key]: value,
        }

        // Set the updated diskConfigs back to the corresponding VM
        updatedVMs[vmIndex] = {
          ...updatedVMs[vmIndex],
          diskConfigs: updatedDisks,
        }

        return updatedVMs
      }

      if (platform === 'azure') {
        return {
          ...state,
          vmConfigsAzure: updateConfigs(state.vmConfigsAzure),
        }
      } else {
        return {
          ...state,
          vmConfigs: updateConfigs(state.vmConfigs),
        }
      }
    }
    case 'RESET_DISKS': {
      const { vmIndex, platform } = action.payload

      const resetDisks = (vmConfigs) =>
        vmConfigs.map((vm, index) =>
          index === vmIndex ? { ...vm, diskConfigs: [] } : vm
        )

      if (platform === 'azure') {
        return {
          ...state,
          vmConfigsAzure: resetDisks(state.vmConfigsAzure),
        }
      } else {
        return {
          ...state,
          vmConfigs: resetDisks(state.vmConfigs),
        }
      }
    }
    case 'SET_NETWORK_RG_NAMES':
      return {
        ...state,
        networkRgNames: action.payload,
        firstNetworkRgName: action.payload.length > 0 ? action.payload[0] : ''
      }
    case 'SET_SELECTED_NETWORK_RG_NAME':
      return { ...state, selectedNetworkRgName: action.payload }
    case 'SET_NSG_NAMES':
      return { ...state, nsgNames: action.payload }
    case 'SET_NSG_NAME':
      return { ...state, nsgName: action.payload }
    case 'SET_ASG_NAMES': {
      return { ...state, asgNames: Array.isArray(action.payload) ? action.payload : [] }
    }

    case 'SET_NSG_ASSOCIATION_TYPE':
      return {
        ...state,
        nsgAssociationType: action.payload,
        vmConfigsAzure: [...state.vmConfigsAzure] // Ensure vmConfigs are preserved
      }
    case 'SET_NSG_SLIDER_ENABLED':
      return {
        ...state,
        nsgSliderEnabled: action.payload.enabled // Set the NSG slider state based on the action payload
      }
    case 'SET_SAVE_ENABLED_TAB':
      // Based on which tab to enable (2 or 3)
      if (action.payload.tab === 2) {
        return {
          ...state,
          isSaveEnabledTab2: action.payload.enabled
        }
      } else if (action.payload.tab === 3) {
        return {
          ...state,
          isSaveEnabledTab3: action.payload.enabled
        }
      }
      break
    case 'SET_NSG_TYPE':
      return { ...state, nsgType: action.payload }
    case 'SET_NSG_LOCATION':
      return { ...state, nsgLocation: action.payload }
    case 'SET_FIRST_NETWORK_RG_NAME':
      return { ...state, firstNetworkRgName: action.payload }
    case 'SET_IS_DATAFOUNDATION_USER':
      return { ...state, isDataFoundationUser: action.payload }
    case 'SET_DATA_FOUNDATION_USERS':
      return { ...state, dataFoundationUsers: action.payload }
    default:
      return state
  }
}

export const setIsDataFoundationUser = (isDFUser) => ({ type: "SET_IS_DATAFOUNDATION_USER", payload: isDFUser })
export const setDataFoundationUsers = (users) => ({ type: "SET_DATA_FOUNDATION_USERS", payload: users })

